/* Carrousel d'images des cartes produit (Sprint 2 — personnalisation Ava Be).
   Défini en module autonome pour ne pas toucher theme.js : le défilement
   tactile est 100 % CSS (scroll-snap) ; ce script ne gère que les flèches
   desktop et l'état des points indicateurs. */
if (!customElements.get('avb-card-carousel')) {
  class AvbCardCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.avb-card-carousel__track');
      if (!this.track || this.track.children.length < 2) return;

      this.dots = Array.from(this.querySelectorAll('.avb-card-carousel__dot'));
      this.slideCount = this.dots.length || this.track.children.length;
      this.prevButton = this.querySelector('[data-avb-prev]');
      this.nextButton = this.querySelector('[data-avb-next]');
      this._rafId = null;
      this._index = 0;

      /* POURQUOI L'INDICATEUR NE SUIVAIT PAS LE DOIGT SUR IPHONE.
         L'index était recalculé dans un écouteur `scroll` posé sur la
         piste, à partir de scrollLeft. Sur ordinateur, où le défilement
         se termine net, cela suffit. Sur iOS, le geste se prolonge en
         inertie et la position n'est pas fiable au moment où l'on
         mesure : l'indicateur restait sur la première image.

         Un IntersectionObserver répond directement à la bonne question
         — quelle image occupe la vue ? — sans mesurer ni scrollLeft ni
         largeur. C'est le navigateur qui tranche, et il tranche à la
         fin du geste comme pendant. */
      this._observateur = new IntersectionObserver(
        (entrees) => {
          entrees.forEach((entree) => {
            if (!entree.isIntersecting) return;
            const position = this._slides().indexOf(entree.target);
            if (position !== -1) {
              this._index = position;
              this._update();
            }
          });
        },
        {
          root: this.track,
          /* 0,6 plutôt que 0,5 : à la moitié exacte, deux images
             peuvent être signalées dans le même lot et la dernière
             traitée gagne, au hasard de l'ordre. */
          threshold: 0.6,
        }
      );

      this._slides().forEach((slide) => this._observateur.observe(slide));

      this.prevButton?.addEventListener('click', () => this._scrollBySlide(-1));
      this.nextButton?.addEventListener('click', () => this._scrollBySlide(1));

      this._update();
    }

    disconnectedCallback() {
      this._observateur?.disconnect();
    }

    _slides() {
      return Array.from(this.track.children);
    }

    _scrollBySlide(direction) {
      const rtl = getComputedStyle(this).direction === 'rtl';
      this.track.scrollBy({
        left: direction * this.track.clientWidth * (rtl ? -1 : 1),
        behavior: 'smooth'
      });
    }

    _update() {
      const index = this._index;

      this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));

      if (this.prevButton) this.prevButton.disabled = index === 0;
      if (this.nextButton) this.nextButton.disabled = index === this.slideCount - 1;
    }
  }

  customElements.define('avb-card-carousel', AvbCardCarousel);
}

/* Swatch King injecte sur chaque carte un custom element
   <variant-swatch-king> comme enfant direct de <product-card> (DOM constaté
   en preview : div.swatches.swatches-type-collections > .swatch-single /
   label.swatch-label), que le CSS de l'app affiche en overlay bas de photo.
   On replace l'élément complet dans l'emplacement dédié .avb-card-swatches,
   sous le prix (rendu par snippets/product-card.liquid). L'app injectant en
   asynchrone, on observe le DOM ; une fois déplacé, l'élément est contenu
   dans l'emplacement et n'est donc pas retraité (pas de boucle). Hors des
   cartes (fiche produit), closest('.product-card') échoue : aucun impact. 
(() => {
  const SK_SELECTOR = 'variant-swatch-king, .swatches';

  const relocate = (element) => {
    if (!(element instanceof Element) || !element.matches(SK_SELECTOR)) return;

    const target = element.closest('variant-swatch-king') || element;
    const card = target.closest('.product-card');
    if (!card) return;

    const slot = card.querySelector('.avb-card-swatches');
    if (slot && !slot.contains(target) && !target.contains(slot)) {
      slot.appendChild(target);
    }
  };

  const scan = (root) => {
    if (!(root instanceof Element)) return;
    relocate(root);
    root.querySelectorAll(SK_SELECTOR).forEach(relocate);
  };

  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach(scan);
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scan(document.body), { once: true });
  } else {
    scan(document.body);
  }
})(); */
